import React, { Component } from "react";
import { connect } from "react-redux";

import { Table, Input } from "antd";
import { usrRole } from "../../utils/dataUtil";
import { API_BASE } from "../../utils/contrains";
import { getSSPAcademicYear } from "../../utils/dateUtil";
import {
  req_list_ssp_school_plan_month,
  req_downloadfile_ssp_school_plan_month,
} from "../../api";

class SchoolPlanMonthHistory extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    planAcademicYear: getSSPAcademicYear(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
    obj: {},
    colleges: [
      // { label: "管理學院", value: "59" },
      { label: "民生暨管理學院", value: "60" },
      { label: "設計學院", value: "62" },
      { label: "藝術學院", value: "63" },
      // { label: "旅遊學院", value: "193" },
    ],
    targetdeparts: [
      { value: "187", label: "應用英語系", group: "60" },
      { value: "196", label: "旅館管理系", group: "60" },
      { value: "214", label: "養生休閒管理系", group: "60" },
      { value: "161", label: "企業管理系", group: "60" },
      { value: "24", label: "資訊管理系", group: "60" },
      { value: "7", label: "國際企業經營系", group: "60" },
      { value: "8", label: "財務金融系", group: "60" },
      { value: "165", label: "餐飲系", group: "60" },
      { value: "178", label: "生活服務產業系", group: "60" },
      { value: "199", label: "運動休閒與健康管理系", group: "60" },
      { value: "3", label: "服飾設計管理系", group: "60" },
      { value: "4", label: "美容造型設計系", group: "60" },
      { value: "5", label: "幼兒保育系", group: "60" },
      { value: "11", label: "室內設計系", group: "62" },
      { value: "159", label: "時尚設計系", group: "62" },
      { value: "164", label: "多媒體動畫系", group: "62" },
      { value: "17", label: "視覺傳達設計系", group: "62" },
      { value: "18", label: "商品設計系", group: "62" },
      { value: "212", label: "漫畫系", group: "63" },
      { value: "19", label: "美術系", group: "63" },
      { value: "20", label: "音樂系", group: "63" },
      { value: "21", label: "舞蹈系", group: "63" },
      { value: "213", label: "流行音樂系", group: "63" },
    ],
    targetdepartlist: [],
    targetprincipals: [],
    sourcehighSchools: [],
    sourcedeparts: [],
    academicSystems: [
      { label: "四技", value: "四技" },
      { label: "七技", value: "七技" },
    ],
    sourceCodes: [
      { value: "AA", label: "商管群(A)" },
      { value: "AB", label: "餐旅群(A)" },
      { value: "AC", label: "設計群(A)" },
      { value: "AD", label: "藝術群(A)" },
      { value: "AE", label: "機械群(A)" },
      { value: "AF", label: "食品群(A)" },
      { value: "AG", label: "土木群(A)" },
      { value: "AH", label: "外語群英語類(A)" },
      { value: "AI", label: "電子與電機群資電類(A)" },
      { value: "AJ", label: "家政群生活應用類(A)" },
      { value: "AK", label: "家政群幼保類(A)" },
      { value: "AM", label: "農業類(A)" },
      { value: "BA", label: "藝術單招(B1)" },
      { value: "BB", label: "特殊選才(B2)" },
      { value: "BC", label: "繁星入學(B3)" },
      { value: "BD", label: "運優單招(B4)" },
      { value: "BE", label: "一般獨招(B5)" },
      { value: "CA", label: "四技申請(高中生)(C)" },
      { value: "DA", label: "技優甄審(D)" },
    ],
    selectedCollege: "NONE",
    targetDepartmentCode: "NONE",
    countyCityName: "NONE",
    searchField: "NONE",
    searchValue: "",
  };

  componentWillMount() {}

  //////////
  api_list_studentsource = async () => {
    const {
      planAcademicYear,
      targetDepartmentCode,
      selectedCollege,
      searchField,
      searchValue,
    } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_school_plan_month(
      userCode,
      userLevel,
      planAcademicYear,
      selectedCollege,
      targetDepartmentCode,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      const totalPlan = items.reduce((accumulator, object) => {
        return accumulator + object.TotalNum;
      }, 0);
      const totalConfident = items.reduce((accumulator, object) => {
        return accumulator + object.TotalConfident;
      }, 0);
      this.setState({ data: items, totalPlan, totalConfident });
    } else {
      const items = [];
      this.setState({ data: items, totalPlan: 0, totalConfident: 0 });
    }
  };

  api_downloadfile_items = async () => {
    const {
      planAcademicYear,
      targetDepartmentCode,
      selectedCollege,
      searchField,
      searchValue,
    } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    // download file data
    const fileUrl = await req_downloadfile_ssp_school_plan_month(
      userCode,
      userLevel,
      planAcademicYear,
      selectedCollege,
      targetDepartmentCode,
      searchField,
      searchValue,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  api_list_target_depart = (value) => {
    const result = this.state.targetdeparts.filter(function (el) {
      return el.group === value;
    });
    const targetdepartlist = result.length > 0 ? result : [];
    this.setState({ targetdepartlist });
    //console.log("targetdepartlist:", targetdepartlist);
  };

  //////////
  handle_data_refresh = () => {
    //this.api_list_studentsource_noloading();
    // const { targetDepartmentCode } = this.state;
    // if (targetDepartmentCode === "NONE") {
    //   message.info("請選擇系所!!");
    // } else {
    //   this.api_list_studentsource();
    // }
    this.api_list_studentsource();
    //console.log("refresh");
  };

  handle_show_ui_modal = (modal, item) => {
    // console.log("handle_show_ui_modal");
    switch (modal) {
      case "download":
        this.api_downloadfile_items();

        break;
      default:
    }
  };

  handleCollegeChange = (event) => {
    this.setState({
      selectedCollege: event.target.value,
      targetDepartmentCode: "NONE",
    });
    this.setTargetdeparts(event.target.value);
    //console.log(value);
  };

  handleTargetdepartChange = (event) => {
    const value = event.target.value;
    this.setState({
      targetDepartmentCode: value,
    });
  };

  handleSelectChange = (event) => {
    const value = event.target.value;
    this.setState({
      searchField: value,
    });
  };

  setTargetdeparts = (value) => {
    this.api_list_target_depart(value);
  };

  //////////
  render() {
    const {
      planAcademicYear,
      colleges,
      selectedCollege,
      targetdepartlist,
      targetDepartmentCode,
      data,
      loading,
      searchField,
      searchValue,
    } = this.state;
    const columns = [
      {
        title: "學制",
        align: "center",
        dataIndex: "AcademicSystem",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "系所",
        dataIndex: "DeptmentShortName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "生源學校",
        dataIndex: "HighSchoolTwName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "生源科班",
        dataIndex: "DepartmentName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }

          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "01月異動",
        width: 180,
        responsive: ["lg"],
        children: [
          {
            title: "規劃",
            dataIndex: "NumberOfPeopleM01",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 0 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
          {
            title: "預收",
            dataIndex: "NumberConfidentM01",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 0 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
        ],
      },
      {
        title: "02月異動",
        width: 180,
        responsive: ["lg"],
        children: [
          {
            title: "規劃",
            dataIndex: "NumberOfPeopleM02",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 1 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
          {
            title: "預收",
            dataIndex: "NumberConfidentM02",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 1 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
        ],
      },
      {
        title: "03月異動",
        width: 180,
        responsive: ["lg"],
        children: [
          {
            title: "規劃",
            dataIndex: "NumberOfPeopleM03",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 2 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
          {
            title: "預收",
            dataIndex: "NumberConfidentM03",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 2 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
        ],
      },
      {
        title: "04月異動",
        width: 180,
        children: [
          {
            title: "規劃",
            dataIndex: "NumberOfPeopleM04",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 3 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
          {
            title: "預收",
            dataIndex: "NumberConfidentM04",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 3 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
        ],
      },
      {
        title: "05月異動",
        width: 180,
        responsive: ["lg"],
        children: [
          {
            title: "規劃",
            dataIndex: "NumberOfPeopleM05",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 4 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
          {
            title: "預收",
            dataIndex: "NumberConfidentM05",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 4 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
        ],
      },
      {
        title: "06月異動",
        width: 180,
        responsive: ["lg"],
        children: [
          {
            title: "規劃",
            dataIndex: "NumberOfPeopleM06",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 5 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
          {
            title: "預收",
            dataIndex: "NumberConfidentM06",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 5 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
        ],
      },
      {
        title: "07月異動",
        width: 180,
        responsive: ["lg"],
        children: [
          {
            title: "規劃",
            dataIndex: "NumberOfPeopleM07",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 6 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
          {
            title: "預收",
            dataIndex: "NumberConfidentM07",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 6 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
        ],
      },
      {
        title: "08月異動",
        width: 180,
        responsive: ["lg"],
        children: [
          {
            title: "規劃",
            dataIndex: "NumberOfPeopleM08",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 7 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
          {
            title: "預收",
            dataIndex: "NumberConfidentM08",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 7 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
        ],
      },
      {
        title: "09月異動",
        width: 180,
        responsive: ["lg"],
        children: [
          {
            title: "規劃",
            dataIndex: "NumberOfPeopleM09",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 8 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
          {
            title: "預收",
            dataIndex: "NumberConfidentM09",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#FFF";
              const datetime = new Date();
              const month = datetime.getMonth();
              var bgColor = month === 8 ? "#FFD700" : "#FFF";
              switch (record.CollegeCode) {
                case "60": //生活科技學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: textColor,
                    backgroundColor: bgColor,
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
        ],
      },
    ];

    return (
      <>
        <div className="form-group">
          <Input
            placeholder="規劃年度"
            style={{
              width: 55,
              height: 39,
              margin: "0 5px",
              color: "red",
            }}
            onChange={(event) =>
              this.setState({ planAcademicYear: event.target.value })
            }
            value={planAcademicYear}
            readOnly={true}
            disabled={true}
          />
          <select
            className="form-control"
            style={{
              width: "160px",
              display: "inline-block",
            }}
            onChange={this.handleCollegeChange}
            value={selectedCollege}
          >
            <option key={"NONE"} value={"NONE"}>
              請選擇學院
            </option>
            {colleges.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
          <select
            className="form-control"
            style={{
              width: "180px",
              display: "inline-block",
            }}
            onChange={this.handleTargetdepartChange}
            value={targetDepartmentCode}
          >
            <option key={"NONE"} value={"NONE"}>
              請選擇系所
            </option>
            {targetdepartlist.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
          <select
            className="form-control"
            style={{ width: "180px", display: "inline-block" }}
            onChange={this.handleSelectChange}
            value={searchField}
          >
            <option key={"NONE"} value="NONE">
              其他條件
            </option>
            <option key={"HighSchoolTwName"} value="HighSchoolTwName">
              生源學校校名
            </option>
          </select>
          <Input
            placeholder="關鍵字"
            style={{
              width: 80,
              height: 39,
              margin: "0 5px",
              backgroundColor: "LightYellow",
            }}
            value={searchValue}
            onChange={(event) =>
              this.setState({ searchValue: event.target.value })
            }
          />
          <button
            className="btn btn-info"
            onClick={this.handle_data_refresh}
            style={{
              marginLeft: "2px",
              marginBottom: "6px",
              display: "inline-block",
            }}
          >
            <i className="fas fa-search element-hidden"></i>
            <span style={{ marginLeft: "4px" }}>查詢</span>
          </button>
          <button
            className="btn btn-info"
            onClick={this.handle_data_refresh}
            style={{
              marginLeft: "2px",
              marginBottom: "6px",
              display: "inline-block",
            }}
          >
            <i className="fas fa-sync-alt"></i>
          </button>
          <button
            className="btn btn-info"
            onClick={() => this.handle_show_ui_modal("download", {})}
            style={{ marginLeft: "2px", marginBottom: "6px" }}
          >
            <i className="fas fa-cloud-download-alt"></i>
          </button>
        </div>
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SchoolPlanMonthHistory);
